/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const vp = require('public/js/components/vehicle');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/
	(function SearchFiltersModule() {
		function handleFilterOverlayClose() {
			rp$('#filters-overlay').removeClass('active');
			rp$('.rp_page_linksbutton').css({ display: 'inline' });
		}

		$onReady({
			rp$, window,
			label: 'search_filters',
			fn: function () {
				const $search_filters_modules = rp$('.search-filters-module');

				let $hamburger_menu_button = rp$('.rp_page_linksbutton');

                rp$('.mobile-filters-close-button').on('click', () => { handleFilterOverlayClose(); });

				const filterButton = rp$('#mobile-filters-button');
				if (filterButton && filterButton.length) {
					filterButton.prependTo(filterButton.closest('.page-builder-layout-row'));

					filterButton[0].addEventListener('click', () => {
						rp$('#filters-overlay')[0].classList.add('active');

						if ($hamburger_menu_button) {
							$hamburger_menu_button.css({ display: 'none' });
						}
					});

					rp$('#mobile-filters-apply-button').on('click', () => { handleFilterOverlayClose(); });
					rp$('#mobile-filters-clear-button').on('click', () => { handleFilterOverlayClose(); });
				}

				rp$.each($search_filters_modules, function DropDownMenu_Iterator(idx, search_filters_module) {
					const $filtersForm = rp$(search_filters_module).find('.refine-search-form');
					const $makeFilter = $filtersForm.find('.refine-make-select');
					const $modelFilter = $filtersForm.find('.refine-model-select');
					const $yearFilter = $filtersForm.find('.refine-year-select');

					const getFilters = () => {
						return {
							make: $makeFilter.val(),
							model: $modelFilter.val(),
							year: $yearFilter.val(),
							search_str: $filtersForm.data('search-str'),
							page_id: $filtersForm.data('page-id'),
							page_url: $filtersForm.data('page-url')
						};
					};

					const handleFilterChange = function() {
						const filters = getFilters();
						handleFilterApply();

						vp.fetchYmmFilters(filters)
							.then((result={}) => {
								const data = result.data;

								if (data.years) {
									const yearData = vp.getDropdownContentFromData(data.years);
									vp.updateDropdownElement($yearFilter, yearData, filters.year);
								}
								if (data.makes) {
									const makeData = vp.getDropdownContentFromData(data.makes);
									vp.updateDropdownElement($makeFilter, makeData, filters.make);
								}
								if (data.models) {
									const modelData = vp.getDropdownContentFromData(data.models);
									vp.updateDropdownElement($modelFilter, modelData, filters.model);
								}
							});
					};

					const handleFilterApply = () => {
						const filters = getFilters();
						$filtersForm.trigger('changeFilters', ['', filters]);
					};

					$filtersForm.on('change', '.refine-select', (e) => {
						e.preventDefault();
						handleFilterChange();
					});
					$filtersForm.on('click', '.refine-reset', (e) => {
						e.preventDefault();
						$makeFilter.val('');
						$modelFilter.val('');
						$yearFilter.val('');
						handleFilterChange();
					});

					const $clearMobileFiltersButton = rp$('#mobile-filters-clear-button');
					if ($clearMobileFiltersButton && $clearMobileFiltersButton.length) {
						$clearMobileFiltersButton.on('click', () => {
							let filtersChanged = false;

							if (! $makeFilter.prop('disabled')) {
								$makeFilter.val('');
								filtersChanged = true;
							}
							if (! $modelFilter.prop('disabled')) {
								$modelFilter.val('');
								filtersChanged = true;
							}
							if (! $yearFilter.prop('disabled')) {
								$yearFilter.val('');
								filtersChanged = true;
							}

							if (filtersChanged) {
								handleFilterChange();
							}
						});
					}
					// $filtersForm.on('click', '.refine-submit', (e) => {
					// 	e.preventDefault();
					// 	handleFilterApply();
					// });

					/* Handle Search Response
					.*-----------------------------------------*/
					rp$(document).on('searchResults:response', (e, response={}) => {
						const yearData = vp.getDropdownContentFromData(response.filters.years);
						const makeData = vp.getDropdownContentFromData(response.filters.makes);
						const modelData = vp.getDropdownContentFromData(response.filters.models);
						vp.updateDropdownElement($yearFilter, yearData, response.year);
						vp.updateDropdownElement($makeFilter, makeData, response.make);
						vp.updateDropdownElement($modelFilter, modelData, response.model);
					});

				}); // END rp$.each module
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
